
import {useState, useEffect} from 'react'
import { motion } from 'framer-motion'
import { X, Filter as FilterIcon, Calendar, Building2, Package, Tag, CreditCard, Clock, Loader2, Search } from 'lucide-react'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import ReportFilter from './ReportFilter'
import {useDistributors, useRegions, useIndustries} from '../../../app/modules/auth'

const FilterModal = (props:any) => {
  const { onChange, onClose, data, type } = props
  
  const distributors = useDistributors()
  const industries = useIndustries()
  const regions = useRegions()

  const [loading, setLoading] = useState(false)
  const [selectedDistributors, setSelectedDistributors] = useState([])
  const [selectedIndustries, setSelectedIndustries] = useState([])
  const [selectedRegions, setSelectedRegions] = useState([])
  const [status, setStatus] = useState(type === 'preco_estoque_hist' ? 'DataPreco' : 'captado')
  const [cnpj, setCNPJ] = useState('')
  const [regraPromocao, setRegraPromocao] = useState('')
  const [idPedido, setIdPedido] = useState('')
  const [idSKU, setIdSKU] = useState('')
  const [EAN, setEAN] = useState('')
  const [produto, setProduto] = useState('')
  const [grupo, setGrupo] = useState('')
  const [familiaProduto, setFamiliaProduto] = useState('')
  const [marca, setMarca] = useState('')
  const [politicaPreco, setPoliticaPreco] = useState('')
  const [dataFaturadoIntegracao, setDataFaturadoIntegracao] = useState('')
  const [dataNFIntegracao, setDataNFIntegracao] = useState('')
  const [groupBySKU, setGroupBySKU] = useState('')
  const [meioPagamento, setMeioPagamento] = useState('')
  const [prazoPagamento, setPrazoPagamento] = useState('')
  const [idRegra, setIdRegra] = useState('')
  const [filter, setFilter] = useState<any>(null)
  const [startDate, setStartDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000))
  const [endDate, setEndDate] = useState(new Date())
  
  const minDate = new Date(new Date(new Date().setMonth(new Date().getMonth() - 18)))
  const maxDate = new Date()

  useEffect(() => {
    setLoading(false)
  }, [])

  useEffect(() => {
    clear()
    if (filter || data) {
      const filterData = filter?.data || data
      if (filterData.status) setStatus(filterData.status)
      if (filterData.distributors) setSelectedDistributors(filterData.distributors)
      if (filterData.industries) setSelectedIndustries(filterData.industries)
      if (filterData.dtstart) setStartDate(new Date(new Date(filterData.dtstart).setDate(new Date(filterData.dtstart).getDate() + 1)))
      if (filterData.dtend) setEndDate(new Date(new Date(filterData.dtend).setDate(new Date(filterData.dtend).getDate() + 1)))
      if (filterData.cnpj) setCNPJ(filterData.cnpj)
      if (filterData.idPedido) setIdPedido(filterData.idPedido)
      if (filterData.idSKU) setIdSKU(filterData.idSKU)
      if (filterData.produto) setProduto(filterData.produto)
      if (filterData.politicaPreco) setPoliticaPreco(filterData.politicaPreco)
      if (filterData.ean) setEAN(filterData.ean)
      if (filterData.regraPromocao) setRegraPromocao(filterData.regraPromocao)
      if (filterData.regions) setSelectedRegions(filterData.regions)
      if (filterData.marca) setMarca(filterData.marca)
      if (filterData.dataNFIntegracao) setDataNFIntegracao(filterData.dataNFIntegracao)
      if (filterData.groupBySKU) setGroupBySKU(filterData.groupBySKU)
      if (filterData.dataFaturadoIntegracao) setDataFaturadoIntegracao(filterData.dataFaturadoIntegracao)
      if (filterData.grupo) setGrupo(filterData.grupo)
      if (filterData.familiaProduto) setFamiliaProduto(filterData.familiaProduto)
      if (filterData.meioPagamento) setMeioPagamento(filterData.meioPagamento)
      if (filterData.prazoPagamento) setPrazoPagamento(filterData.prazoPagamento)
      if (filterData.idRegra) setIdRegra(filterData.idRegra)
    }
  }, [data, filter])

  function clear() {
    setStatus(type === 'preco_estoque_hist' ? 'DataPreco' : 'captado')
    setSelectedDistributors([])
    setSelectedIndustries([])
    setStartDate(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000))
    setEndDate(new Date())
    setCNPJ('')
    setIdPedido('')
    setIdSKU('')
    setProduto('')
    setPoliticaPreco('')
    setEAN('')
    setRegraPromocao('')
    setSelectedRegions([])
    setMarca('')
    setDataNFIntegracao('')
    setGroupBySKU('')
    setDataFaturadoIntegracao('')
    setGrupo('')
    setFamiliaProduto('')
    setMeioPagamento('')
    setPrazoPagamento('')
    setIdRegra('')
  }

  function getData() {
    return {
      status,
      distributors: selectedDistributors,
      industries: selectedIndustries,
      dtstart: getStringDate(startDate),
      dtend: getStringDate(endDate),
      cnpj,
      idPedido,
      idSKU,
      produto,
      politicaPreco,
      ean: EAN,
      regraPromocao,
      regions: selectedRegions,
      marca,
      dataNFIntegracao,
      dataFaturadoIntegracao,
      groupBySKU,
      grupo,
      familiaProduto,
      meioPagamento,
      prazoPagamento,
      idRegra,
    }
  }

  function getStringDate(date:any) {
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    const dayFormatted = day < 10 ? '0' + day : day.toString()
    const monthFormatted = month < 10 ? '0' + month : month.toString()
    return `${year}-${monthFormatted}-${dayFormatted}`
  }

  const customSelectStyles = {
    control: (base:any) => ({
      ...base,
      borderRadius: '0.5rem',
      minHeight: '38px',
      borderColor: '#d1d5db', // gray-300
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#9ca3af', // gray-400
      },
      '&:focus-within': {
        borderColor: '#3b82f6', // blue-500
        boxShadow: '0 0 0 1px #3b82f6', // ring-blue-500
      },
    }),
    multiValue: (base:any) => ({
      ...base,
      backgroundColor: '#e0e7ff', // indigo-100
      borderRadius: '0.25rem',
    }),
    multiValueLabel: (base:any) => ({
      ...base,
      color: '#4338ca', // indigo-700
      fontWeight: 500,
    }),
    multiValueRemove: (base:any) => ({
      ...base,
      color: '#4338ca', // indigo-700
      '&:hover': {
        backgroundColor: '#c7d2fe', // indigo-200
        color: '#3730a3', // indigo-800
      },
    }),
    menu: (base:any) => ({
      ...base,
      zIndex: 9999, // Ensure menu is above the modal
    }),
    menuPortal: (base:any) => ({
      ...base,
      zIndex: 9999, // Ensure menuPortal is above the modal
    }),
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }} onClick={() => onClose()} className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
      
      <motion.div initial={{ opacity: 0, scale: 0.95, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95, y: 20 }} transition={{ type: 'spring', damping: 25, stiffness: 300 }} className="relative bg-white rounded-lg shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        
        <div className="bg-white border-b p-4 flex-shrink-0">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-bold text-gray-900">Filtros do Relatório</h2>
              <p className="text-gray-600 text-sm mt-1">Configure os parâmetros de busca</p>
            </div>
            <button onClick={() => onClose()} className="text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="border-b">
          <ReportFilter name={type} filter={getData()} setFilter={setFilter} />
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-6">
            
            <div className="bg-gray-50 rounded-lg p-4 border">
              <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center">
                <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                Período e Status
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                  {type !== 'preco_estoque_hist' ? (
                    <select disabled={loading} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={status} onChange={(evt) => setStatus(evt.target.value)}>
                      <option value='captado'>Captado</option>
                      <option value='aprovado'>Aprovado</option>
                      <option value='faturado'>Faturado</option>
                      <option value='entregue'>Entregue</option>
                      <option value='cancelado'>Cancelado</option>
                      {(type === 'pedidos' || type === 'promocoes') && <option value='apurado'>Apurado</option>}
                    </select>
                  ) : (
                    <select disabled={loading} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={status} onChange={(evt) => setStatus(evt.target.value)}>
                      <option value='DataPreco'>Data Preço</option>
                      <option value='DataEstoque'>Data Estoque</option>
                    </select>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Data Início</label>
                  <DatePicker disabled={loading} dateFormat={'dd/MM/yyyy'} selected={startDate} onChange={(date:any) => setStartDate(date)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" minDate={minDate} maxDate={maxDate} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Data Término</label>
                  <DatePicker disabled={loading} dateFormat={'dd/MM/yyyy'} selected={endDate} onChange={(date:any) => setEndDate(date)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" minDate={minDate} maxDate={maxDate} />
                </div>
                {(type === 'pedidos' || type === 'promocoes') && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Agrupado por Pedido</label>
                    <div className="flex items-center space-x-4 h-[38px]">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" type='radio' name='groupBySKU' value='SIM' checked={groupBySKU === 'SIM'} onChange={({target: {value}}) => setGroupBySKU(value)} />
                        <span className="text-sm text-gray-700">Sim</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" type='radio' name='groupBySKU' value='' checked={groupBySKU === ''} onChange={({target: {value}}) => setGroupBySKU(value)} />
                        <span className="text-sm text-gray-700">Não</span>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {type !== 'preco_estoque_hist' && (
              <div className="bg-gray-50 rounded-lg p-4 border">
                <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center">
                  <Building2 className="w-4 h-4 mr-2 text-gray-600" />
                  Informações da Empresa
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">CNPJ</label>
                    <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={cnpj} onChange={(e) => setCNPJ(e.target.value)} placeholder="00.000.000/0000-00" />
                  </div>
                  {(type === 'pedidos' || type === 'notafiscal') && (
                    <>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
                          <CreditCard className="w-3.5 h-3.5 mr-1.5" />
                          Meio de Pagamento
                        </label>
                        <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={meioPagamento} onChange={(e) => setMeioPagamento(e.target.value)} placeholder="Ex: Boleto, Cartão..." />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
                          <Clock className="w-3.5 h-3.5 mr-1.5" />
                          Prazo de Pagamento
                        </label>
                        <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={prazoPagamento} onChange={(e) => setPrazoPagamento(e.target.value)} placeholder="Ex: 30 dias" />
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}

            <div className="bg-gray-50 rounded-lg p-4 border">
              <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center">
                <Package className="w-4 h-4 mr-2 text-gray-600" />
                Informações do Produto
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {type !== 'preco_estoque_hist' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">ID do Pedido</label>
                    <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={idPedido} onChange={(e) => setIdPedido(e.target.value)} placeholder="ID do pedido" />
                  </div>
                )}
                {type !== 'notafiscal' && type !== 'preco_estoque_hist' && groupBySKU === '' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">ID SKU</label>
                    <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={idSKU} onChange={(e) => setIdSKU(e.target.value)} placeholder="ID do SKU" />
                  </div>
                )}
                {type !== 'notafiscal' && groupBySKU === '' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Nome do Produto</label>
                    <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={produto} onChange={(e) => setProduto(e.target.value)} placeholder="Nome do produto" />
                  </div>
                )}
                {type === 'preco_estoque_hist' && (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">EAN</label>
                      <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={EAN} onChange={(e) => setEAN(e.target.value)} placeholder="Código EAN" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Marca</label>
                      <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={marca} onChange={(e) => setMarca(e.target.value)} placeholder="Marca do produto" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Política Preço</label>
                      <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={politicaPreco} onChange={(e) => setPoliticaPreco(e.target.value)} placeholder="Política de preço" />
                    </div>
                  </>
                )}
                {type === 'promocoes' && groupBySKU === '' && (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nome Promoção</label>
                      <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={regraPromocao} onChange={(e) => setRegraPromocao(e.target.value)} placeholder="Nome da promoção" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">ID Regra</label>
                      <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={idRegra} onChange={(e) => setIdRegra(e.target.value)} placeholder="ID da regra" />
                    </div>
                  </>
                )}
                {(type === 'promocoes' || type === 'pedidos') && groupBySKU === '' && (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Grupo</label>
                      <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={grupo} onChange={(e) => setGrupo(e.target.value)} placeholder="Grupo do produto" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Família Produto</label>
                      <input className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type='text' disabled={loading} value={familiaProduto} onChange={(e) => setFamiliaProduto(e.target.value)} placeholder="Família do produto" />
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-4 border">
              <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center">
                <Tag className="w-4 h-4 mr-2 text-gray-600" />
                Filtros Múltiplos
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Distribuidor</label>
                  <Select 
                    isMulti 
                    isDisabled={loading} 
                    options={distributors} 
                    value={selectedDistributors} 
                    placeholder='Selecione os distribuidores...' 
                    closeMenuOnSelect={false} 
                    onChange={(selected:any) => setSelectedDistributors(selected)} 
                    styles={customSelectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
                {groupBySKU === '' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Indústria</label>
                    <Select 
                      isMulti 
                      isDisabled={loading} 
                      options={industries} 
                      value={selectedIndustries} 
                      placeholder='Selecione as indústrias...' 
                      closeMenuOnSelect={false} 
                      onChange={(selected:any) => setSelectedIndustries(selected)} 
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>
                )}
                {type !== 'preco_estoque_hist' && groupBySKU === '' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Regional</label>
                    <Select 
                      isMulti 
                      isDisabled={loading} 
                      options={regions} 
                      value={selectedRegions} 
                      placeholder='Selecione as regionais...' 
                      closeMenuOnSelect={false} 
                      onChange={(selected:any) => setSelectedRegions(selected)} 
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>
                )}
              </div>
            </div>

            {type === 'notafiscal' && (
              <div className="bg-gray-50 rounded-lg p-4 border">
                <h3 className="text-base font-bold text-gray-900 mb-4">Opções de Integração</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-3">Data Nota Fiscal Integração</label>
                    <div className="flex flex-wrap gap-3">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" type='radio' name='nfIntegracao' value='' checked={dataNFIntegracao === ''} onChange={({target: {value}}) => setDataNFIntegracao(value)} />
                        <span className="text-sm text-gray-700">Todos</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" type='radio' name='nfIntegracao' value='SIM' checked={dataNFIntegracao === 'SIM'} onChange={({target: {value}}) => setDataNFIntegracao(value)} />
                        <span className="text-sm text-gray-700">Sim</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" type='radio' name='nfIntegracao' value='NAO' checked={dataNFIntegracao === 'NAO'} onChange={({target: {value}}) => setDataNFIntegracao(value)} />
                        <span className="text-sm text-gray-700">Não</span>
                      </label>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-3">Data Faturado Integração</label>
                    <div className="flex flex-wrap gap-3">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" type='radio' name='dataFaturadoIntegracao' value='' checked={dataFaturadoIntegracao === ''} onChange={({target: {value}}) => setDataFaturadoIntegracao(value)} />
                        <span className="text-sm text-gray-700">Todos</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" type='radio' name='dataFaturadoIntegracao' value='SIM' checked={dataFaturadoIntegracao === 'SIM'} onChange={({target: {value}}) => setDataFaturadoIntegracao(value)} />
                        <span className="text-sm text-gray-700">Sim</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" type='radio' name='dataFaturadoIntegracao' value='NAO' checked={dataFaturadoIntegracao === 'NAO'} onChange={({target: {value}}) => setDataFaturadoIntegracao(value)} />
                        <span className="text-sm text-gray-700">Não</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="bg-gray-50 border-t p-4 flex-shrink-0">
          <div className="flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-end gap-3">
            <button onClick={() => { clear(); onClose(); }} className="px-6 py-2 text-gray-700 hover:bg-gray-200 font-medium rounded-md transition-colors">
              Limpar e Fechar
            </button>
            <button onClick={() => { setLoading(true); onChange(getData()); }} disabled={loading} className="px-6 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-md transition-colors flex items-center justify-center space-x-2">
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span>Filtrando...</span>
                </>
              ) : (
                <>
                  <Search className="w-4 h-4" />
                  <span>Aplicar Filtros</span>
                </>
              )}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default FilterModal
